import { render, staticRenderFns } from "./addCtg.vue?vue&type=template&id=81a92ec6&scoped=true&"
import script from "./addCtg.vue?vue&type=script&lang=js&"
export * from "./addCtg.vue?vue&type=script&lang=js&"
import style0 from "./addCtg.vue?vue&type=style&index=0&id=81a92ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a92ec6",
  null
  
)

export default component.exports